import { z } from "zod";
import { isArray } from "lodash";

import { auditEventBaseSchema } from "./audit-event-base";
import { auditEventTypeSchema } from "./audit-event-type";
import { auditEventImportFailedSchema } from "./audit-event-import-failed";
import { auditEventStagedFailedSchema } from "./audit-event-staged-failed";

export const auditEventFailedSchema = auditEventBaseSchema
	.extend({
		auditType: z.literal(auditEventTypeSchema.enum.Failed),
	})
	.transform((event, ctx) => {
		if (isArray(event.data.importLog)) {
			return {
				...event,
				auditType: auditEventTypeSchema.enum.ImportFailed,
			};
		}

		if (event.data.failureReason) {
			return {
				...event,
				auditType: auditEventTypeSchema.enum.StagedFailed,
			};
		}

		ctx.addIssue({
			code: z.ZodIssueCode.custom,
			message: "Failed to transform Failed event",
		});
	})
	.pipe(z.union([auditEventImportFailedSchema, auditEventStagedFailedSchema]));

export type AuditEventFailed = z.infer<typeof auditEventFailedSchema>;
